/**
 * List of countries with ISO codes for flag rendering
 * Flags: https://flagscdn.com/w20/{iso_code}.png
 */
export const COUNTRIES = [
  { id: 1, name: 'Afghanistan', iso_code: 'af' },
  { id: 2, name: 'Albania', iso_code: 'al' },
  { id: 3, name: 'Algeria', iso_code: 'dz' },
  { id: 4, name: 'Andorra', iso_code: 'ad' },
  { id: 5, name: 'Angola', iso_code: 'ao' },
  { id: 6, name: 'Antigua and Barbuda', iso_code: 'ag' },
  { id: 7, name: 'Argentina', iso_code: 'ar' },
  { id: 8, name: 'Armenia', iso_code: 'am' },
  { id: 9, name: 'Australia', iso_code: 'au' },
  { id: 10, name: 'Austria', iso_code: 'at' },
  { id: 11, name: 'Azerbaijan', iso_code: 'az' },
  { id: 12, name: 'Bahamas', iso_code: 'bs' },
  { id: 13, name: 'Bahrain', iso_code: 'bh' },
  { id: 14, name: 'Bangladesh', iso_code: 'bd' },
  { id: 15, name: 'Barbados', iso_code: 'bb' },
  { id: 16, name: 'Belarus', iso_code: 'by' },
  { id: 17, name: 'Belgium', iso_code: 'be' },
  { id: 18, name: 'Belize', iso_code: 'bz' },
  { id: 19, name: 'Benin', iso_code: 'bj' },
  { id: 20, name: 'Bhutan', iso_code: 'bt' },
  { id: 21, name: 'Bolivia', iso_code: 'bo' },
  { id: 22, name: 'Bosnia and Herzegovina', iso_code: 'ba' },
  { id: 23, name: 'Botswana', iso_code: 'bw' },
  { id: 24, name: 'Brazil', iso_code: 'br' },
  { id: 25, name: 'Brunei', iso_code: 'bn' },
  { id: 26, name: 'Bulgaria', iso_code: 'bg' },
  { id: 27, name: 'Burkina Faso', iso_code: 'bf' },
  { id: 28, name: 'Burundi', iso_code: 'bi' },
  { id: 29, name: 'Cambodia', iso_code: 'kh' },
  { id: 30, name: 'Cameroon', iso_code: 'cm' },
  { id: 31, name: 'Canada', iso_code: 'ca' },
  { id: 32, name: 'Cape Verde', iso_code: 'cv' },
  { id: 33, name: 'Central African Republic', iso_code: 'cf' },
  { id: 34, name: 'Chad', iso_code: 'td' },
  { id: 35, name: 'Chile', iso_code: 'cl' },
  { id: 36, name: 'China', iso_code: 'cn' },
  { id: 37, name: 'Colombia', iso_code: 'co' },
  { id: 38, name: 'Comoros', iso_code: 'km' },
  { id: 39, name: 'Congo', iso_code: 'cg' },
  { id: 40, name: 'Costa Rica', iso_code: 'cr' },
  { id: 41, name: 'Croatia', iso_code: 'hr' },
  { id: 42, name: 'Cuba', iso_code: 'cu' },
  { id: 43, name: 'Cyprus', iso_code: 'cy' },
  { id: 44, name: 'Czech Republic', iso_code: 'cz' },
  { id: 45, name: 'Denmark', iso_code: 'dk' },
  { id: 46, name: 'Djibouti', iso_code: 'dj' },
  { id: 47, name: 'Dominica', iso_code: 'dm' },
  { id: 48, name: 'Dominican Republic', iso_code: 'do' },
  { id: 49, name: 'DR Congo', iso_code: 'cd' },
  { id: 50, name: 'Ecuador', iso_code: 'ec' },
  { id: 51, name: 'Egypt', iso_code: 'eg' },
  { id: 52, name: 'El Salvador', iso_code: 'sv' },
  { id: 53, name: 'Equatorial Guinea', iso_code: 'gq' },
  { id: 54, name: 'Eritrea', iso_code: 'er' },
  { id: 55, name: 'Estonia', iso_code: 'ee' },
  { id: 56, name: 'Eswatini', iso_code: 'sz' },
  { id: 57, name: 'Ethiopia', iso_code: 'et' },
  { id: 58, name: 'Fiji', iso_code: 'fj' },
  { id: 59, name: 'Finland', iso_code: 'fi' },
  { id: 60, name: 'France', iso_code: 'fr' },
  { id: 61, name: 'Gabon', iso_code: 'ga' },
  { id: 62, name: 'Gambia', iso_code: 'gm' },
  { id: 63, name: 'Georgia', iso_code: 'ge' },
  { id: 64, name: 'Germany', iso_code: 'de' },
  { id: 65, name: 'Ghana', iso_code: 'gh' },
  { id: 66, name: 'Greece', iso_code: 'gr' },
  { id: 67, name: 'Grenada', iso_code: 'gd' },
  { id: 68, name: 'Guatemala', iso_code: 'gt' },
  { id: 69, name: 'Guinea', iso_code: 'gn' },
  { id: 70, name: 'Guinea-Bissau', iso_code: 'gw' },
  { id: 71, name: 'Guyana', iso_code: 'gy' },
  { id: 72, name: 'Haiti', iso_code: 'ht' },
  { id: 73, name: 'Honduras', iso_code: 'hn' },
  { id: 74, name: 'Hungary', iso_code: 'hu' },
  { id: 75, name: 'Iceland', iso_code: 'is' },
  { id: 76, name: 'India', iso_code: 'in' },
  { id: 77, name: 'Indonesia', iso_code: 'id' },
  { id: 78, name: 'Iran', iso_code: 'ir' },
  { id: 79, name: 'Iraq', iso_code: 'iq' },
  { id: 80, name: 'Ireland', iso_code: 'ie' },
  { id: 81, name: 'Israel', iso_code: 'il' },
  { id: 82, name: 'Italy', iso_code: 'it' },
  { id: 83, name: 'Ivory Coast', iso_code: 'ci' },
  { id: 84, name: 'Jamaica', iso_code: 'jm' },
  { id: 85, name: 'Japan', iso_code: 'jp' },
  { id: 86, name: 'Jordan', iso_code: 'jo' },
  { id: 87, name: 'Kazakhstan', iso_code: 'kz' },
  { id: 88, name: 'Kenya', iso_code: 'ke' },
  { id: 89, name: 'Kiribati', iso_code: 'ki' },
  { id: 90, name: 'Kuwait', iso_code: 'kw' },
  { id: 91, name: 'Kyrgyzstan', iso_code: 'kg' },
  { id: 92, name: 'Laos', iso_code: 'la' },
  { id: 93, name: 'Latvia', iso_code: 'lv' },
  { id: 94, name: 'Lebanon', iso_code: 'lb' },
  { id: 95, name: 'Lesotho', iso_code: 'ls' },
  { id: 96, name: 'Liberia', iso_code: 'lr' },
  { id: 97, name: 'Libya', iso_code: 'ly' },
  { id: 98, name: 'Liechtenstein', iso_code: 'li' },
  { id: 99, name: 'Lithuania', iso_code: 'lt' },
  { id: 100, name: 'Luxembourg', iso_code: 'lu' },
  { id: 101, name: 'Madagascar', iso_code: 'mg' },
  { id: 102, name: 'Malawi', iso_code: 'mw' },
  { id: 103, name: 'Malaysia', iso_code: 'my' },
  { id: 104, name: 'Maldives', iso_code: 'mv' },
  { id: 105, name: 'Mali', iso_code: 'ml' },
  { id: 106, name: 'Malta', iso_code: 'mt' },
  { id: 107, name: 'Marshall Islands', iso_code: 'mh' },
  { id: 108, name: 'Mauritania', iso_code: 'mr' },
  { id: 109, name: 'Mauritius', iso_code: 'mu' },
  { id: 110, name: 'Mexico', iso_code: 'mx' },
  { id: 111, name: 'Micronesia', iso_code: 'fm' },
  { id: 112, name: 'Moldova', iso_code: 'md' },
  { id: 113, name: 'Monaco', iso_code: 'mc' },
  { id: 114, name: 'Mongolia', iso_code: 'mn' },
  { id: 115, name: 'Montenegro', iso_code: 'me' },
  { id: 116, name: 'Morocco', iso_code: 'ma' },
  { id: 117, name: 'Mozambique', iso_code: 'mz' },
  { id: 118, name: 'Myanmar', iso_code: 'mm' },
  { id: 119, name: 'Namibia', iso_code: 'na' },
  { id: 120, name: 'Nauru', iso_code: 'nr' },
  { id: 121, name: 'Nepal', iso_code: 'np' },
  { id: 122, name: 'Netherlands', iso_code: 'nl' },
  { id: 123, name: 'New Zealand', iso_code: 'nz' },
  { id: 124, name: 'Nicaragua', iso_code: 'ni' },
  { id: 125, name: 'Niger', iso_code: 'ne' },
  { id: 126, name: 'Nigeria', iso_code: 'ng' },
  { id: 127, name: 'North Korea', iso_code: 'kp' },
  { id: 128, name: 'North Macedonia', iso_code: 'mk' },
  { id: 129, name: 'Norway', iso_code: 'no' },
  { id: 130, name: 'Oman', iso_code: 'om' },
  { id: 131, name: 'Pakistan', iso_code: 'pk' },
  { id: 132, name: 'Palau', iso_code: 'pw' },
  { id: 133, name: 'Palestine', iso_code: 'ps' },
  { id: 134, name: 'Panama', iso_code: 'pa' },
  { id: 135, name: 'Papua New Guinea', iso_code: 'pg' },
  { id: 136, name: 'Paraguay', iso_code: 'py' },
  { id: 137, name: 'Peru', iso_code: 'pe' },
  { id: 138, name: 'Philippines', iso_code: 'ph' },
  { id: 139, name: 'Poland', iso_code: 'pl' },
  { id: 140, name: 'Portugal', iso_code: 'pt' },
  { id: 141, name: 'Qatar', iso_code: 'qa' },
  { id: 142, name: 'Romania', iso_code: 'ro' },
  { id: 143, name: 'Russia', iso_code: 'ru' },
  { id: 144, name: 'Rwanda', iso_code: 'rw' },
  { id: 145, name: 'Saint Kitts and Nevis', iso_code: 'kn' },
  { id: 146, name: 'Saint Lucia', iso_code: 'lc' },
  { id: 147, name: 'Saint Vincent and the Grenadines', iso_code: 'vc' },
  { id: 148, name: 'Samoa', iso_code: 'ws' },
  { id: 149, name: 'San Marino', iso_code: 'sm' },
  { id: 150, name: 'Sao Tome and Principe', iso_code: 'st' },
  { id: 151, name: 'Saudi Arabia', iso_code: 'sa' },
  { id: 152, name: 'Senegal', iso_code: 'sn' },
  { id: 153, name: 'Serbia', iso_code: 'rs' },
  { id: 154, name: 'Seychelles', iso_code: 'sc' },
  { id: 155, name: 'Sierra Leone', iso_code: 'sl' },
  { id: 156, name: 'Singapore', iso_code: 'sg' },
  { id: 157, name: 'Slovakia', iso_code: 'sk' },
  { id: 158, name: 'Slovenia', iso_code: 'si' },
  { id: 159, name: 'Solomon Islands', iso_code: 'sb' },
  { id: 160, name: 'Somalia', iso_code: 'so' },
  { id: 161, name: 'South Africa', iso_code: 'za' },
  { id: 162, name: 'South Korea', iso_code: 'kr' },
  { id: 163, name: 'South Sudan', iso_code: 'ss' },
  { id: 164, name: 'Spain', iso_code: 'es' },
  { id: 165, name: 'Sri Lanka', iso_code: 'lk' },
  { id: 166, name: 'Sudan', iso_code: 'sd' },
  { id: 167, name: 'Suriname', iso_code: 'sr' },
  { id: 168, name: 'Sweden', iso_code: 'se' },
  { id: 169, name: 'Switzerland', iso_code: 'ch' },
  { id: 170, name: 'Syria', iso_code: 'sy' },
  { id: 171, name: 'Taiwan', iso_code: 'tw' },
  { id: 172, name: 'Tajikistan', iso_code: 'tj' },
  { id: 173, name: 'Tanzania', iso_code: 'tz' },
  { id: 174, name: 'Thailand', iso_code: 'th' },
  { id: 175, name: 'Timor-Leste', iso_code: 'tl' },
  { id: 176, name: 'Togo', iso_code: 'tg' },
  { id: 177, name: 'Tonga', iso_code: 'to' },
  { id: 178, name: 'Trinidad and Tobago', iso_code: 'tt' },
  { id: 179, name: 'Tunisia', iso_code: 'tn' },
  { id: 180, name: 'Turkey', iso_code: 'tr' },
  { id: 181, name: 'Turkmenistan', iso_code: 'tm' },
  { id: 182, name: 'Tuvalu', iso_code: 'tv' },
  { id: 183, name: 'Uganda', iso_code: 'ug' },
  { id: 184, name: 'Ukraine', iso_code: 'ua' },
  { id: 185, name: 'United Arab Emirates', iso_code: 'ae' },
  { id: 186, name: 'United Kingdom', iso_code: 'gb' },
  { id: 187, name: 'United States', iso_code: 'us' },
  { id: 188, name: 'Uruguay', iso_code: 'uy' },
  { id: 189, name: 'Uzbekistan', iso_code: 'uz' },
  { id: 190, name: 'Vanuatu', iso_code: 'vu' },
  { id: 191, name: 'Vatican City', iso_code: 'va' },
  { id: 192, name: 'Venezuela', iso_code: 've' },
  { id: 193, name: 'Vietnam', iso_code: 'vn' },
  { id: 194, name: 'Yemen', iso_code: 'ye' },
  { id: 195, name: 'Zambia', iso_code: 'zm' },
  { id: 196, name: 'Zimbabwe', iso_code: 'zw' }
];

export const COUNTRY_OPTIONS = COUNTRIES.map((c) => ({ value: c.name, label: c.name }));

/**
 * Get flag URL for a country
 * @param {string} isoCode - ISO country code (lowercase)
 * @returns {string} - URL to country flag image
 */
export const getCountryFlagUrl = (isoCode) => {
  return `https://flagscdn.com/w20/${isoCode}.png`;
};
